var moo$1 = {exports: {}};

export { moo$1 as __module };
//# sourceMappingURL=moo.mjs.map
